import { Link } from "react-router-dom";
import {
  Headset,
  MessageSquare,
  PhoneIncoming,
  PhoneOutgoing,
  CheckCircle,
  ArrowRight,
  Shield,
  Globe,
  MessageCircle,
  Smartphone,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import Layout from "@/components/layout/Layout";
import PageHeader from "@/components/layout/PageHeader";
import Seo from "@/components/Seo";
import { SERVICES } from "@/data/siteData";

// Channel icons mapping
const channelIcons = {
  WhatsApp: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  ),
  Messenger: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#0084FF">
      <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.3 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111S18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8l3.131 3.259L19.752 8l-6.561 6.963z"/>
    </svg>
  ),
  Viber: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#7360F2">
      <path d="M11.4 0C9.5.1 5.4.4 3.1 2.5 1.4 4.2.6 6.7.5 9.8c-.1 3.1-.1 9 5.5 10.6v2.4s0 1 .6 1.2c.7.2 1.1-.5 1.8-1.2.3-.4.8-.9 1.1-1.3 2.9.2 5.1-.3 5.4-.4.6-.2 3.9-.6 4.4-5 .6-4.5-.3-7.4-1.8-8.7-.4-.4-2.2-1.7-6.4-1.8 0 0-.4 0-.8 0zm.4 1.5h.7c3.6.1 5.1 1.1 5.5 1.5 1.3 1.1 2 3.6 1.5 7.6-.5 3.8-3.2 4.1-3.7 4.3-.2.1-2.1.5-4.6.4 0 0-1.8 2.2-2.4 2.8-.1.1-.2.1-.3.1-.1 0-.1-.1-.1-.3V14.5c-4.9-1.4-4.6-6.5-4.5-9.2.1-2.7.8-4.8 2.2-6.2 1.7-1.6 5.1-1.9 5.7-1.6zm.1 2.8c-.1 0-.2.1-.2.2s.1.2.2.2c1.7.1 3 .5 4 1.4.9.9 1.4 2.1 1.4 3.8 0 .1.1.2.2.2s.2-.1.2-.2c0-1.8-.6-3.2-1.6-4.2-1-.9-2.5-1.4-4.3-1.4zm-3.7.6c-.2 0-.4.1-.4.1-.3.1-.5.3-.7.5l-.5.5c-.2.2-.3.5-.3.8 0 .3.1.5.2.8.3.6.8 1.5 1.5 2.4.8.9 1.8 2 3 2.8 1 .7 1.7.9 2.4 1.1.7.2 1.3.4 2.1.2.5-.1.9-.3 1.1-.7.3-.3.4-.8.4-1.2 0-.4-.3-.7-.6-.9-.3-.2-.7-.4-1-.5-.7-.3-1.3-.5-1.7-.2l-.5.5c-.2.2-.4.2-.6.1-1.2-.5-2-1.2-2.6-2-.6-.7-1-1.4-1.2-1.8-.1-.2-.1-.4.1-.5l.4-.5c.3-.4.2-1-.1-1.6-.2-.3-.3-.5-.5-.8-.2-.2-.3-.5-.5-.6-.1-.1-.3-.1-.4-.1zm3.8.9c-.1 0-.2.1-.2.2s.1.2.2.2c1.1.1 1.9.4 2.5 1 .6.6.9 1.4.9 2.4 0 .1.1.2.2.2s.2-.1.2-.2c0-1.1-.4-2-1.1-2.7-.6-.7-1.6-1-2.8-1.1zm-.1 1.7c-.1 0-.2.1-.2.2s.1.2.2.2c.6 0 1 .2 1.3.5.3.3.4.7.5 1.2 0 .1.1.2.2.2s.2-.1.2-.2c0-.6-.2-1.1-.6-1.5-.4-.4-.9-.6-1.5-.6z"/>
    </svg>
  ),
  Instagram: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#E4405F">
      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
    </svg>
  ),
  Webchat: (
    <MessageCircle className="w-5 h-5 text-[#2E4A91]" />
  ),
  SMS: (
    <Smartphone className="w-5 h-5 text-[#2E4A91]" />
  ),
};

const ServicesPage = () => {
  return (
    <Layout>
      <Seo path="/uslugi" />
      <PageHeader 
        subtitle="Какво предлагаме"
        title="Услуги"
        description="Пълен спектър от комуникационни решения за вашия бизнес"
      />

      {/* Call Center Services */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="service-card-icon">
                  <Headset className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#2E4A91]">
                  Кол-Център Услуги
                </h2>
              </div>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Компанията ни е тясно специализирана в предоставянето на Кол-център услуги и обслужването на крайни клиенти през този комуникационен канал. Имаме дългогодишен опит във всякакъв тип кампании за обслужване на клиенти, като най-много опит имаме в тези от търговски, маркетингов и аналитичен характер.
              </p>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Също така, имаме и голям опит в управлението на входящата „first line" комуникация, като технически запитвания, оплаквания и обратни връзка и тн.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                Подобен тип услуга е подходяща за компании работещи с голям брой клиентска база и крайни клиенти, с които имат комуникация на дневна база. Чрез нас можете да оптимизирате този разход и да дадете добавена стойност на много звена във Вашата компания.
              </p>

              <img
                src="/services-call-center.webp"
                alt="Оператор в кол център обслужва крайни клиенти"
                className="rounded-2xl shadow-lg w-full"
              />
            </div>

            <div className="space-y-6">
              {/* Inbound */}
              <div className="bg-slate-50 rounded-2xl p-6 lg:p-8 border-2 border-[#2E4A91]">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-[#2ED573]/10 flex items-center justify-center">
                    <PhoneIncoming className="w-5 h-5 text-[#2ED573]" />
                  </div>
                  <h3 className="text-xl font-bold text-[#2E4A91]">
                    Входяща линия
                  </h3>
                </div>
                <ul className="space-y-3">
                  {SERVICES.inbound.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-slate-600">
                      <CheckCircle className="w-5 h-5 text-[#2ED573] mt-0.5 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Outbound */}
              <div className="bg-slate-50 rounded-2xl p-6 lg:p-8 border-2 border-[#2E4A91]">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-[#2E4A91]/10 flex items-center justify-center">
                    <PhoneOutgoing className="w-5 h-5 text-[#2E4A91]" />
                  </div>
                  <h3 className="text-xl font-bold text-[#2E4A91]">
                    Изходяща линия
                  </h3>
                </div>
                <ul className="space-y-3">
                  {SERVICES.outbound.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-slate-600">
                      <CheckCircle className="w-5 h-5 text-[#2ED573] mt-0.5 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Voice Messages */}
              <div className="bg-gradient-to-br from-[#2E4A91] to-[#243b75] rounded-2xl p-6 lg:p-8 text-white">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
                    <PhoneOutgoing className="w-5 h-5" />
                  </div>
                  <h3 className="text-xl font-bold">
                    {SERVICES.voiceMessages.title}
                  </h3>
                </div>
                <p className="text-white/90 leading-relaxed">
                  {SERVICES.voiceMessages.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Chat Channel Management */}
      <section className="section-padding bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="order-2 lg:order-1 space-y-8">
              {/* Supported Channels */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm">
                <h3 className="text-xl font-bold text-[#2E4A91] mb-6">
                  Поддържани канали
                </h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                  {SERVICES.channels.map((channel, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-3 px-4 py-3 bg-slate-50 rounded-xl font-medium text-slate-700 border border-slate-100"
                    >
                      {channelIcons[channel]}
                      <span>{channel}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-4 mb-6">
                <div
                  className="service-card-icon"
                  style={{
                    background:
                      "linear-gradient(135deg, #2ED573 0%, #25b861 100%)",
                  }}
                >
                  <MessageSquare className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#2E4A91]">
                  Управление на чат канали
                </h2>
              </div>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Ако компанията Ви е "start-up" и нямате още цял екип от специалисти в обслужването на клиенти или сте по-голяма компания, която иска да оптимизира своят разход като не редуцира качеството и обема си на обслужване, то тогава се свържете с нас относно тази услуга.
              </p>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Нашите специалисти ще поемат цялата входяща комуникация и ще я филтрират към Вашите специалисти при необходимост ако не успеят да съдействат те самите на дадения краен клиент. Така ще спестите време и средства.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                Освен входяща комуникация, нашите специалисти могат да поемат и изходящи кампании и инициативи през каналите, за които нашите партньори са абонирани. Може да генерирате рекламно или информационно съобщение и да го изпратите мигновено до колкото клиенти пожелаете.
              </p>

              <img
                src="https://images.unsplash.com/photo-1611606063065-ee7946f0787a?auto=format&fit=crop&w=800&q=80"
                alt="Чат канали"
                className="rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h3 className="text-center text-xl font-semibold text-slate-700 mb-8">
            Сертификати и доверие
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            <div className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
              <Shield className="w-12 h-12 text-slate-400" />
              <span className="text-sm text-slate-500">ISO 9001</span>
            </div>
            <div className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
              <Shield className="w-12 h-12 text-slate-400" />
              <span className="text-sm text-slate-500">ISO 27001</span>
            </div>
            <div className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
              <Shield className="w-12 h-12 text-slate-400" />
              <span className="text-sm text-slate-500">PCI DSS</span>
            </div>
            <div className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
              <Globe className="w-12 h-12 text-slate-400" />
              <span className="text-sm text-slate-500">GDPR</span>
            </div>
            <div className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
              <CheckCircle className="w-12 h-12 text-slate-400" />
              <span className="text-sm text-slate-500">AAA Рейтинг</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gradient-to-r from-[#2E4A91] to-[#243b75] py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Готови да подобрите обслужването?
          </h2>
          <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
            Свържете се с нас за безплатна консултация и индивидуална оферта
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/zapazi-chas">
              <Button className="bg-white text-[#2E4A91] hover:bg-slate-100 text-lg px-8 h-14 rounded-lg font-semibold">
                Запазете консултация
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/ceni">
              <Button
                variant="outline"
                className="border-white text-white hover:bg-white/10 text-lg px-8 h-14 rounded-lg font-semibold"
              >
                Вижте цените
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ServicesPage;
